import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate, useSearchParams } from 'react-router-dom';

const BackButton = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const source = searchParams.get('source');

  const canGoBack = window.history.length > 1;

  if (!canGoBack) return null;

  return (
    <div
      className="back-button-2"
      onClick={() => (source === 'category_form' ? navigate(-2) : navigate(-1))}
    >
      <ArrowBackIcon fontSize="small" />
      <span>&nbsp;Back</span>
    </div>
  );
};
export default BackButton;
